function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m2010 140 20 20",
    style: {
      fill: "none"
    },
    transform: "translate(-2008 -138)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2010 140 20 20",
    style: {
      fill: "none"
    },
    transform: "matrix(-1 0 0 1 2032 -138)"
  }));
};
export default SvgIconClose;